module.exports = __webpack_public_path__ + "img/5.78c225f5.jpg";